import axios from 'axios'

const axiosIns = axios.create({
  baseURL: `${import.meta.env.VITE_BASE_URL}/api`,
})

axiosIns.interceptors.request.use(config => {
  const token = localStorage.getItem('accessToken')
  if (token && token !== 'false') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

export default axiosIns
